import assign from 'lodash/assign'
import isEmpty from 'lodash/isEmpty'
import isString from 'lodash/isString'

import accounting from 'accounting'
import moment from 'moment'
import config from 'config'

import externalFormatAmount from '@/modules/_helpers/formatAmount'

const makeString = (num, unit) => `${+num}${unit}`

export class CssHelper {
  static px() {
    return Array.from(arguments).reduce((result, current) => result + `${makeString(current, 'px')} `, '')
  }

  static percent() {
    return Array.from(arguments).reduce((result, current) => result + `${makeString(current, '%')} `, '')
  }

  static important(value) {
    return `${value} !important`
  }

  static border(color) {
    return `1px solid ${color}`
  }

  static sub(percent, margin) {
    return `calc(${percent}% - ${margin}px)`
  }

  static alpha(color, alpha) {
    return `${color}${(Math.floor(alpha * 255).toString(16))}`
  }
}

export default {
  _: {
    assign,
    isEmpty,
  },

  abbreviate: function(str, length) {
    return str.length > length ? `${str.substring(0, length)}.` : str
  },

  // formatting helpers for use in templates
  helpers: {
    accounting,
    moment,

    formatDate: function(date, format) {
      // return if date is undefined
      if (!date) { return }

      if (!isString(date) && date.toISOString) {
        date = date.toISOString()
      }

      format = format || config.dateFormat.api
      date = date.split('T')
      return moment(date, format).format('DD.MM.YYYY')
    },

    formatTime: function(date, format) {
      // return if date is undefined
      if (!date) { return }
      if (date && !isString(date) && date.toISOString) {
        date = date.toISOString()
      }

      format = format || config.datetimeFormat.api
      date = date.split('T')
      return moment(date, format).format('HH:mm')
    },

    formatWeight: function(weight) {
      const formatConfig = {
        ...config.currencyFormat,
        symbol: 'kg',
        precision: 3,
      }
      return accounting.formatMoney(weight, formatConfig)
    },

    formatCurrency: function(euro) {
      return accounting.formatMoney(euro, config.currencyFormat)
    },

    formatCurrencyTruncated: function(value) {
      return accounting.formatNumber(value, config.currencyFormat).split(',')[0] + ` ${config.currencyFormat.symbol}`
    },

    formatCurrencyRounded: function(value) {
      const roundedValue = parseFloat(accounting.toFixed(value, 2), 10)
      return this.formatCurrency(roundedValue)
    },
    formatAmount: function(value) {
      return externalFormatAmount(value)
    },
  },
}
